import { FunctionComponent } from 'react';
import { Image, Button } from '@chakra-ui/react';
import { InterestProviderItem, InterestProvidersListMortgageTypes } from '../../../@types';
import { getProductImage } from './utils';
import { FormattedMessage, useIntl } from 'react-intl';

interface InterestProvidesListItemProps {
  item: InterestProviderItem;
  selectedMortgageType: InterestProvidersListMortgageTypes | undefined;
  selectedBuildingType: string | undefined;
  selectedEnergyLabel: string | undefined;
}
export const InterestProviderListItem: FunctionComponent<InterestProvidesListItemProps> = ({
  item,
  selectedMortgageType,
  selectedEnergyLabel,
  selectedBuildingType
}) => {
  const intl = useIntl();
  const goToCalculator = () => {
    const url =
      intl.locale === 'nl'
        ? '/zelf-berekenen/wat-worden-mijn-maandlasten/calculator/'
        : '/en/calculators-and-checks/mortgage-payment/calculator/';
    window.location.href = `${url}?productid=${item.lookupId}&isnewbuilding=${
      selectedBuildingType === 'Nieuwbouw'
    }&energylabel=${selectedEnergyLabel}`;
  };

  const hasCalculatorButton =
    selectedMortgageType === 'Annuiteitenhypotheek' ||
    selectedMortgageType === 'Lineaire_hypotheek';

  return (
    <>
      <div
        className={`grid grid-cols-1 md:grid-cols-8 mb-6 md:mb-2 md:gap-4 items-center justify-center bg-white rounded-3xl md:rounded md:min-h-[80px] p-10 md:p-0`}>
        <div className={`flex md:justify-start col-span-1 md:col-span-1`}>
          <Image
            className={`md:ml-4`}
            maxW={`100px`}
            w={[`75px`, `100px`, `99%`]}
            src={getProductImage(item.logoUrl)}></Image>
        </div>
        <div
          className={`col-span-1 ${
            hasCalculatorButton ? 'md:col-span-3' : 'md:col-span-5'
          } text-center md:text-left`}>
          <div className={`flex items-center font-bold`}>{item.aanbiederNaam}</div>
        </div>
        <div className={`col-span-1 md:col-span-1 md:text-left`}>
          <div>{item.hypotheekNaam}</div>
        </div>
        <div
          className={`-mt-[50px] md:mt-0 text-right md:text-left col-span-1 md:w-[75px] md:text-4xl`}>
          <div className={`font-bold md:hidden`}>Rente</div>
          {item.rentestand.toFixed(2).replace('.', intl.locale === 'nl' ? ',' : '.')}%
        </div>
        {hasCalculatorButton && (
          <div
            className={`flex mt-6 md:mt-0 justify-center md:justify-end lg:max-w-2xl col-span-1 md:col-span-2 md:mr-8`}>
            <Button
              className={`w-full md:w-auto`}
              variant={`outline`}
              size={`slim`}
              onClick={goToCalculator}
              colorScheme={`blue`}>
              <FormattedMessage
                id={'item.calculateMonthlyCosts'}
                defaultMessage={'Bereken je maandlasten'}
              />
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
